import React, { useEffect, useRef, useState } from "react";
import Footer from "../widgets/Footer";
import Navbar from "../widgets/Navbar";
import { formatDecimal } from "../../util/decimalFormatter";
import { useNavigate } from "react-router-dom";
import { useGetallUserQuery } from "../../redux/userApi";
import { useSelector } from "react-redux";
import {
  useGetAccountListsQuery,
  useSwitchAccountMutation,
  useUpdaetUserNicknameMutation,
  useUpdateAccountBalanceDummyMutation,
} from "../../redux/accountApi";
import {
  useGetSelectedLeverageQuery,
  useGetUserForexPortfolioMutation,
  useLeverageByUserQuery,
  useUpdateLeverageUserMutation,
} from "../../redux/forexApi";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { ForgotValid } from "../validations/ForgotValid";
import { useTranslation } from "react-i18next";
import { resetPassword } from "../constant/Api";
import Sidebar from "../widgets/Sidebar";

const MultiAccount = () => {
  const token = localStorage.getItem("jwtToken");
  const { t } = useTranslation();
  const userSegment = useSelector((state) => state.user);

  const { is_master_trader, role, account_type } = userSegment?.userData || {};
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const { data } = useGetallUserQuery();
  const [tabActive, setTabActive] = useState("real");
  const [userLeverage, setUserLeverage] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [modelType, setModelType] = useState("");
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [accountData, setAccountData] = useState([]);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [text, setText] = useState("");
  const [enableDropDown, setEnableDropDown] = useState(false);
  const [freeBalance, setFreeBalance] = useState(0.0);
  const [selectedLeverage, setSelectedLeverage] = useState("");
  const [leverageList, setLeverageList] = useState([]);
  const [isMasterActive, setIsMasterActive] = useState(false);
  const [isSubIBActive, setIsSubIBActive] = useState(false);
  const [totalBalance, setTotalBalance] = useState(0.0);
  const [oldPassword, setOldPassword] = useState("");
  const [confirmType, setConfirmType] = useState("password");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [dummyBalanceAmount, setDummyBalanceAmount] = useState("");
  const [passwordShow, setPasswordShow] = useState({
    eye: "bi-eye-slash",
    type: "password",
  });
  const [passwordFiledErr, setPasswordFiledErr] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [oldPasswordErr, setOldPasswordErr] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [type, setType] = useState("password");
  const [newType, setNewType] = useState("password");
  const [nickname, setNickname] = useState("");
  const [switchAccountFun] = useSwitchAccountMutation();
  const [userPortfolioForex] = useGetUserForexPortfolioMutation();
  const { data: leverageData } = useLeverageByUserQuery();
  const [updateUserLeverage] = useUpdateLeverageUserMutation();
  const [updateAccountBalanceDummy] = useUpdateAccountBalanceDummyMutation();
  const { data: selectedLeverages, refetch: refetcthUserInfo } =
    useGetSelectedLeverageQuery();
  const [updateNickname] = useUpdaetUserNicknameMutation();
  const { data: accountLists, refetch: refetchAccountList } =
    useGetAccountListsQuery(undefined, {
    refetchOnMountOrArgChange: true,
    pollingInterval: 0, // optional: disable polling
  });
  const username = data?.user_name || "N/A";
  const userNickname = data?.nickname || "N/A";
  const accountType = data?.account_type || "N/A";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (selectedLeverages) {
      setUserLeverage(selectedLeverages.amount);
    } else {
      setUserLeverage(1);
    }
  }, [selectedLeverages]);

  useEffect(() => {
    if (leverageData) {
      setLeverageList(leverageData);
    }
  }, [leverageData]);

  useEffect(() => {
    if (!is_master_trader || !role) return;

    if (role === "Informatic Broker (IB)" && is_master_trader === "1") {
      setIsMasterActive(true);
    }

    if (role === "SubIB") {
      setIsSubIBActive(true);
    }
  }, [is_master_trader, role]);

  useEffect(() => {
    if (token) {
      getEquityPortfolio();

      if (accountLists) {
        setAccountData(accountLists);
      }
    }
  }, [accountLists]);

  const getEquityPortfolio = async () => {
    const data = {
      symbolType: "equity",
    };
    const res = await userPortfolioForex(data);
    const resp = res.data;

    if (resp.status === true) {
      setFreeBalance(resp.data.freeBalance ? resp.data.freeBalance : "0.0");

      setTotalBalance(resp.data.balance ? resp.data.balance : "0.0");
    }
  };

  const closeModal = () => {
    setIsModelOpen(false);
    setModelType("");
    setSelectedAccount(null);
  };

  const showAccordianMap = () => {
    // Filter accounts based on current tab selection (real or demo)
    const filteredAccounts = accountData.filter(
      (account) =>
        account.account_type?.toLowerCase() === tabActive.toLowerCase() &&
        account.user_name !== username
    );

    return filteredAccounts.map((account, index) => {
      return (
        <div className="col-md-6 mb-3 multi_account" key={account.id}>
          <div className="card border br10 bg3 br10 p-3 kk">
            <div className="buyselll_box d-flex mb-4 align-items-center">
              <span className="h6">
                {" "}
                #{account.user_name}{" "}
                <small>
                  {account.account_type === "master" ||
                  account.account_type === "real"
                    ? "REAL"
                    : "DEMO"}
                </small>
              </span>
              <div className="buyselll_box ml-md-auto d-flex  align-items-center">
                {account.account_type === "real" && (
                  <>
                    <button
                      onClick={() => navigate("/account")}
                      className="btn mr-2"
                    >
                      Deposit
                    </button>

                    <button
                      onClick={() => navigate("/account")}
                      className="btn mr-2"
                    >
                      Withdraw
                    </button>
                  </>
                )}
                <button
                  className="btn mr-2"
                  onClick={() => handleCheckUser(account)}
                >
                  Trade
                </button>
                {account.account_type === "demo" && (
                  <button
                    className="btn"
                    onClick={() => handleClickMenueMap("deposit_map", account)}
                  >
                    Set Balance
                  </button>
                )}
                <div className="nav-item  position-relative pl-2">
                  <span
                    className={
                      openDropdownIndex === index ? "active" : "cursor-pointer"
                    }
                    onClick={(e) =>{
                      e.preventDefault()
                      setOpenDropdownIndex(
                        openDropdownIndex === index ? null : index
                      )
                    }
                    }
                  >
                    <i className="bi bi-three-dots-vertical"></i>
                  </span>
                  <br />
                  {/* <span className="h6">Package : {account?.package_name}</span> */}
                  
                  
                  
                  <div
                    ref={dropdownRef}
                    className={`dropdown-menu2 ${
                      openDropdownIndex === index ? "active" : "d-none"
                    }`}
                  >
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault()
                        handleClickMenueMap("leverage", account)}}
                    >
                      Change max leverage
                    </a>
                    <a
                      href="#!"
                      onClick={(e) =>{ 
                        e.preventDefault()
                        handleClickMenueMap("rename", account)}}
                    >
                      Rename account
                    </a>
                    <a
                      href="#!"
                      onClick={(e) =>{
                        e.preventDefault()
                        handleClickMenueMap("account_info", account)
                      }
                      }
                    >
                      Account information
                    </a>
                    <a
                      href="#!"
                      onClick={(e) =>{
                        e.preventDefault()
                        handleClickMenueMap("change_password", account)
                      }
                      }
                    >
                      Change trading password
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body bg2  br10 p-3">
              <div className="d-flex justify-content-between">
                <span>Nick Name</span>
                <span>{account?.nickname}</span>
              </div>
              <hr />
               <div className="d-flex justify-content-between">
                <span>Package</span>
                <span>{account?.package_name}</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <span>Actual leverage</span>
                <span>1:{account.amount || "--"} (max 1:1000)</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <span>Unrealized P&L</span>
                <span>0.00 USD</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <span>Free margin</span>
                <span>{formatDecimal(account.total_balance || 0, 2)} USD</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <span>Equity</span>
                <span>0.00 USD</span>
              </div>
              <hr />
            </div>
          </div>
        </div>
      );
    });
  };

  const handleCheckUser = async (userInfo) => {
    // 1. If userInfo has direct account_type (e.g., from account list map)
    if (userInfo?.account_type) {
      if (userInfo.account_type === "real") {
        console.log("Switched to Real account");
      }
      if (userInfo.account_type === "demo") {
        console.log("Switched to Demo account");
      }

      // 🔄 Switch JWT for selected account
      await switchAccount(userInfo); // userInfo is the account object here
      return;
    }
  };

  const switchAccount = async (account) => {
    try {
      const userInfo = {
        switchId: account.id,
      };

      const response = await switchAccountFun(userInfo);

      const { token } = response.data;

      if (!token) throw new Error("No token returned");

      localStorage.setItem("jwtToken", token);

      setTimeout(() => {
        window.location.href = "/forex/EURUSD";
      }, 1000);
    } catch (err) {
      console.error("Error switching account", err);
    }
  };

  const showcurrentPassword = () => {
    if (type === "password") {
      setPasswordShow({ eye: "bi-eye", type: "text" });
      setType("text");
    } else {
      setPasswordShow({ eye: "bi-eye-slash", type: "password" });
      setType("password");
    }
  };

  const showNewPassword = () => {
    if (newType === "password") {
      setNewType("text");
    } else {
      setNewType("password");
    }
  };

  const showConfirmPassword = () => {
    if (confirmType === "password") {
      setConfirmType("text");
    } else {
      setConfirmType("password");
    }
  };

  const handleClickMenueMap = (type, data) => {
    setIsModelOpen(true);
    setModelType(type);
    setSelectedAccount(data);
    if (type === "leverage") {
      setText("Change max leverage");
    }
    if (type === "rename") {
      setText("Rename account");
    }
    if (type === "account_info") {
      setText("Account information");
    }
    if (type === "change_password") {
      setText("Change trading password");
    }
    if (type === "deposit_map") {
      setText("Set balance for demo account");
    }
  };

  const handleClickMenue = (type, accountType) => {
    setIsModelOpen(true);
    setModelType(type);
    if (type === "leverage") {
      setText("Change max leverage");
    }
    if (type === "rename") {
      setText("Rename account");
    }
    if (type === "account_info") {
      setText("Account information");
    }
    if (type === "change_password") {
      setText("Change trading password");
    }
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    if (name === "oldPassword") {
      if (!value) {
        setOldPasswordErr("This field is required");
      } else {
        setOldPasswordErr("");
      }
      setOldPassword(value);
    }

    if (name === "newPassword") {
      if (!value) {
        setPasswordFiledErr({
          ...passwordFiledErr,
          newPassword: "This field is required",
        });
      }
      setNewPassword(value);
    }
    if (name === "confirmPassword") {
      if (!value) {
        setPasswordFiledErr({
          ...passwordFiledErr,
          confirmPassword: "This field is required",
        });
      } else {
        setPasswordFiledErr({
          ...passwordFiledErr,
          confirmPassword: "",
        });
      }
      setConfirmPassword(value);
    }
    const checkRegister = ForgotValid(name, value);
    console.log("checkRegister", checkRegister);
    setPasswordFiledErr({ ...passwordFiledErr, [name]: checkRegister });

    if (name === "confirmPassword") {
      if (value !== newPassword) {
        setPasswordFiledErr({
          ...passwordFiledErr,
          confirmPassword: "Password does not match",
        });
      } else {
        setPasswordFiledErr({
          ...passwordFiledErr,
          confirmPassword: "",
        });
      }
    }
  };

  const handleSubmitLeverage = async () => {
    const data = {
      selectedId: selectedLeverage,
      accountId: selectedAccount?.id,
    };
    const res = await updateUserLeverage(data);
    const resp = res.data;
    if (resp.status === true) {
      setIsModelOpen(false);
      setText("");
      setSelectedLeverage("");
      setEnableDropDown(false);
      refetchAccountList();
      refetcthUserInfo();
      setSelectedAccount(null);
      toast.success(resp.message);
    }
  };

  const handleSubmitNickname = async () => {
    const data = {
      nickname: nickname,
      accountId: selectedAccount?.id,
    };
    const res = await updateNickname(data);
    const resp = res.data;
    if (resp.status === true) {
      setIsModelOpen(false);
      setText("");
      setNickname("");
      setEnableDropDown(false);
      refetchAccountList();
      refetcthUserInfo();
      setSelectedAccount(null);
      toast.success(resp.message);
    } else {
      toast.error(resp.message);
    }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (!newPassword && !confirmPassword && !oldPassword) {
      setPasswordFiledErr({
        ...passwordFiledErr,
        newPassword: "This field is required",
        confirmPassword: "This field is required",
      });
      setOldPasswordErr("This field is required");
      return false;
    } else {
      setPasswordFiledErr({
        ...passwordFiledErr,
        newPassword: "",
        confirmPassword: "",
      });
    }

    if (newPassword !== confirmPassword) {
      setPasswordFiledErr({
        ...passwordFiledErr,
        confirmPassword: "Password does not match",
      });
      return;
    }

    const ForgotData = {
      oldPassword: oldPassword,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
      accountId: selectedAccount?.id,
    };
    const changePass = await resetPassword(ForgotData);
    const resp = changePass.data;
    console.log("changePass", resp);
    if (resp.status === false) {
      toast.error(t(resp.message));
    } else {
      toast.success(t(resp.message));
      setIsModelOpen(false);
      setText("");
      setNickname("");
      setEnableDropDown(false);
      refetchAccountList();
      refetcthUserInfo();
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setOldPasswordErr("");
      setPasswordFiledErr({
        newPassword: "",
        confirmPassword: "",
      });
      setSelectedAccount(null);
    }
  };

  const handleSubmitAmount = async () => {
    const data = {
      amount: dummyBalanceAmount,
      accountId: selectedAccount?.id,
    };
    const res = await updateAccountBalanceDummy(data);
    const resp = res.data;
    if (resp.status === true) {
      setIsModelOpen(false);
      setText("");
      setNickname("");
      setEnableDropDown(false);
      refetchAccountList();
      refetcthUserInfo();
      setSelectedAccount(null);
      setDummyBalanceAmount("");
      toast.success(resp.message);
    } else {
      toast.error(resp.message);
    }
  };

  return (
    <div>
      <Navbar />
      <section className="p70  pt-md-5 pb-md-5">
        <div className="container">
          <div className="row">
            <Sidebar />
            <div className="col-xl-9 col-lg-8">
              <div class="d-md-flex mb-3 align-items-center">
                <div class="d-flex w-100">
                  <h5 className="mb-3 mb-md-0">
                    {tabActive.toUpperCase()} Accounts
                  </h5>
                  <div class=" buyselll_box  ml-auto">
                    <ul>
                      <li>
                        {" "}
                        <button
                          className={tabActive === "real" ? "active" : ""}
                          onClick={() => setTabActive("real")}
                        >
                          Real
                        </button>
                      </li>
                      <li>
                        <button
                          className={tabActive === "demo" ? "active" : ""}
                          onClick={() => setTabActive("demo")}
                        >
                          Demo
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <button
                  className="btn ml-md-3"
                  onClick={() => {
                    navigate("/new-account");
                  }}
                >
                  <i className="bi bi-plus-lg"></i> Open New Account
                </button>
              </div>

              <div className="row mb-4">
                <div className="col-md-3">
                  <select className="form-control">
                    <option>Newest</option>
                    <option></option>
                  </select>
                </div>
              </div>

              <div className="row">
                {showAccordianMap()}

                {account_type === "master" && tabActive === "real" && (
                  <div className="col-md-6 multi_account">
                    <div className="card border  br10 border bg3 br10 p-3 helo">
                      <div className="buyselll_box d-flex  mb-4   align-items-center">
                        <span className="h6 h6 w-100">
                          #@{username}{" "}
                          <small>
                            {accountType === "master"?"MAIN":""}
                          </small>
                        </span>
                        <div className="buyselll_box  d-inline-flex  align-items-center">
                          {console.log(tabActive, "tabActive")}
                          {account_type === "master" && tabActive === "real" ? (
                            <>
                              <button
                                onClick={() => navigate("/account")}
                                className="btn mr-2"
                              >
                                Deposit
                              </button>

                              <button
                                onClick={() => navigate("/account")}
                                className="btn mr-2"
                              >
                                Withdraw
                              </button>

                              <button
                                onClick={() => handleCheckUser(userSegment)}
                                className="btn"
                              >
                                Trade
                              </button>

                              <div className="nav-item  position-relative pl-2">
                                <span
                                  className={
                                    openDropdownIndex === 1111
                                      ? "active"
                                      : "cursor-pointer"
                                  }
                                  onClick={() =>
                                    setOpenDropdownIndex(
                                      openDropdownIndex === 1111 ? null : 1111
                                    )
                                  }
                                  // onClick={() => setEnableDropDown(!enableDropDown)}
                                  // onClick={() => setOpenDropdownIndex(1111)}
                                >
                                  {console.log(
                                    openDropdownIndex,
                                    "openDropdownIndex"
                                  )}
                                  <i className="bi bi-three-dots-vertical"></i>
                                </span>
                                <div
                                  ref={dropdownRef}
                                  className={`dropdown-menu2 ${
                                    openDropdownIndex === 1111
                                      ? "active"
                                      : "d-none"
                                  }`}
                                >
                                  <a
                                    href="#!"
                                    onClick={() =>
                                      handleClickMenue("leverage", "master")
                                    }
                                  >
                                    {" "}
                                    Change max leverage{" "}
                                  </a>
                                  <a
                                    href="#!"
                                    onClick={() =>
                                      handleClickMenue("rename", "master")
                                    }
                                  >
                                    {" "}
                                    Rename account
                                  </a>
                                  <a
                                    href="#!"
                                    onClick={() =>
                                      handleClickMenue("account_info", "master")
                                    }
                                  >
                                    {" "}
                                    Account information
                                  </a>
                                  <a
                                    href="#!"
                                    onClick={() =>
                                      handleClickMenue(
                                        "change_password",
                                        "master"
                                      )
                                    }
                                  >
                                    {" "}
                                    Change trading password
                                  </a>
                                </div>
                              </div>
                            </>
                          ) : (
                            <ul className="nav buy_sell_tab ">
                              <li className="nav-item ">
                                <button
                                  onClick={() => handleCheckUser(userSegment)}
                                  className="btn  mr2 "
                                >
                                  Trade
                                </button>
                              </li>
                              <li className="nav-item ">
                                <button className="btn">Set Balance</button>
                              </li>
                              <li className="nav-item  position-relative">
                                <button
                                  className={enableDropDown ? "btn" : ""}
                                  onClick={() =>
                                    setEnableDropDown(!enableDropDown)
                                  }
                                >
                                  <i className="bi bi-three-dots-vertical"></i>
                                </button>
                                <div
                                  ref={dropdownRef}
                                  className={
                                    enableDropDown
                                      ? "dropdown-menu2 active"
                                      : "dropdown-menu2"
                                  }
                                >
                                  <a
                                    href="#!"
                                    onClick={() =>
                                      handleClickMenue("leverage", "master")
                                    }
                                  >
                                    Change max leverage{" "}
                                  </a>
                                  <a
                                    href="#!"
                                    onClick={() =>
                                      handleClickMenue("rename", "master")
                                    }
                                  >
                                    Rename account
                                  </a>
                                  <a
                                    href="#!"
                                    onClick={() =>
                                      handleClickMenue("account_info", "master")
                                    }
                                  >
                                    Account information
                                  </a>

                                  <a
                                    href="#!"
                                    onClick={() =>
                                      handleClickMenue(
                                        "change_password",
                                        "master"
                                      )
                                    }
                                  >
                                    Change trading password
                                  </a>
                                </div>
                              </li>
                            </ul>
                          )}
                        </div>
                      </div>

                      <div className="card-body bg2 br10 p-3 borderp">
                        <div className="d-flex  justify-content-between">
                          <span>Actual leverage</span>
                          <span>1:{userLeverage} (max 1:1000)</span>
                        </div>
                        <hr className="hr2" />
                        <div className="d-flex  justify-content-between">
                          <span>Unrealized P&L</span>
                          <span>0.00 USD</span>
                        </div>
                        <hr className="hr2" />
                        <div className="d-flex  justify-content-between">
                          <span>Free margin</span>
                          <span>{formatDecimal(freeBalance, 2)} USD</span>
                        </div>
                        <hr className="hr2" />
                        <div className="d-flex  justify-content-between">
                          <span>Equity</span>
                          <span>0.00 USD</span>
                        </div>
                        <hr className="hr2" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        show={isModelOpen}
        onHide={closeModal}
        className="account-popup-outer"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title className=""> {t(text)}</Modal.Title>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={closeModal}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="pb-md-2">
            <p className="mb-3">
              Account: #{selectedAccount?.user_name || username}
            </p>
            {modelType === "leverage" && (
              <>
                <label> Leverage*</label>
                <select
                  className="form-control"
                  onChange={(e) => setSelectedLeverage(e.target.value)}
                >
                  {leverageList.map((item) => (
                    <option value={item.id} key={item.id}>
                      1:{item.amount}
                    </option>
                  ))}
                </select>
                <div className="alert alert-warning mt-3 d-flex">
                  <i className="bi bi-exclamation-triangle mr-3"></i> Your
                  actual leverage may vary depending on various conditions
                  {/* <i className="bi bi-chevron-down ml-auto pl-3"></i> */}
                </div>
                <div className="text-right mt-3">
                  <button className="btn" onClick={handleSubmitLeverage}>
                    Continue
                  </button>
                </div>
              </>
            )}
            {modelType === "rename" && (
              <>
                {/* <p className="mb-3">Account: #{username}</p> */}
                <p className="mb-3">
                  If you have multiple accounts, you can give each one a unique
                  name to make navigation easier.
                </p>

                <label> New nickname*</label>
                <input
                  className="form-control"
                  name="nickname"
                  value={nickname}
                  onChange={(e) => setNickname(e.target.value)}
                  maxLength={35}
                />
                <div className="text-right mt-3">
                  <button className="btn" onClick={handleSubmitNickname}>
                    Continue
                  </button>
                </div>
              </>
            )}
            {modelType === "account_info" && (
              <>
                {/* <p className="mb-3">Account: #{username}</p> */}

                <div className="d-flex  justify-content-between">
                  <span>Nickname</span>
                  <span>{selectedAccount?.nickname || userNickname}</span>
                </div>
                <hr className="hr2" />
                <div className="d-flex  justify-content-between">
                  <span>Actual leverage</span>
                  <span>1:{selectedAccount?.amount || userLeverage}</span>
                </div>
                <hr className="hr2" />
                <div className="d-flex  justify-content-between">
                  <span>Maximum leverage</span>
                  <span>1:2000</span>
                </div>
                <hr className="hr2" />
                <div className="d-flex  justify-content-between">
                  <span>Free margin</span>
                  <span>
                    {formatDecimal(
                      selectedAccount?.total_balance || freeBalance
                    )}{" "}
                    USD
                  </span>
                </div>
                <hr className="hr2" />
                <div className="d-flex  justify-content-between">
                  <span>Unrealized P&L</span>
                  <span>0.00 USD</span>
                </div>
              </>
            )}
            {modelType === "change_password" && (
              <>
                {/* <p className="mb-3">Account: #{username}</p> */}

                <div className="eye_pass position-relative">
                  <div className="row">
                    <div className="form-group col-md-12">
                      <input
                        className="form-control"
                        name="oldPassword"
                        id="oldPassword"
                        placeholder={t("Enter Old Password")}
                        onChange={handleChangeInput}
                        value={oldPassword}
                        type={type}
                      />
                      <span
                        className="password__show position-absolute eye1"
                        onClick={showcurrentPassword}
                      >
                        <i className={`bi ${passwordShow.eye}`}></i>
                      </span>
                      <span className="text-danger">{t(oldPasswordErr)}</span>
                    </div>
                    <div className="form-group col-md-12">
                      <input
                        className="form-control"
                        name="newPassword"
                        id="newPassword"
                        placeholder={t("Enter New Password")}
                        onChange={handleChangeInput}
                        value={newPassword}
                        type={newType}
                      />
                      <span
                        className="password__show position-absolute eye1"
                        onClick={showNewPassword}
                      >
                        {newType === "password" ? (
                          <i className="bi bi-eye-slash"></i>
                        ) : (
                          <i className="bi bi-eye"></i>
                        )}
                      </span>
                      <span className="text-danger">
                        {t(passwordFiledErr.newPassword)}
                      </span>
                    </div>
                    <div className="form-group col-md-12">
                      <input
                        className="form-control"
                        name="confirmPassword"
                        id="confirmPassword"
                        placeholder={t("Enter Confirm Password")}
                        onChange={handleChangeInput}
                        value={confirmPassword}
                        type={confirmType}
                      />
                      <span
                        className="password__show position-absolute eye1"
                        onClick={showConfirmPassword}
                      >
                        {confirmType === "password" ? (
                          <i className="bi bi-eye-slash"></i>
                        ) : (
                          <i className="bi bi-eye"></i>
                        )}
                      </span>
                      <span className="text-danger">
                        {t(passwordFiledErr.confirmPassword)}
                      </span>
                    </div>
                  </div>
                </div>
                <ul className="list mt-3">
                  <li>Between 8-15 characters</li>
                  <li>At least one upper and one lower case letter</li>
                  <li>At least one number</li>
                  <li>At least one special character</li>
                </ul>
                <div className="text-right mt-3">
                  <button className="btn" onClick={changePassword}>
                    Change Password
                  </button>
                </div>
              </>
            )}
            {modelType === "deposit_map" && (
              <>
                <label>Amount*</label>
                <input
                  className="form-control"
                  name="amount"
                  value={dummyBalanceAmount}
                  onChange={(e) => setDummyBalanceAmount(e.target.value)}
                  type="number"
                />
                <div className="text-right mt-3">
                  <button className="btn" onClick={handleSubmitAmount}>
                    Continue
                  </button>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
      <Footer />
    </div>
  );
};

export default MultiAccount;
